import React, { Component } from 'react';
import './LandingDetails.css';
import ReactHtmlParser from 'react-html-parser';

class LandingDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apiKey: 'AIzaSyBsRFWCZD1-BEUp_K8mM6WMi7P9iAJgq3Y',
            addressMapsString: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.event) {
            let addressMapsString = this.props.event.venue.address + "+" + this.props.event.venue.city + "+" + this.props.event.venue.state + "+" + this.props.event.venue.zip
            addressMapsString = encodeURIComponent(addressMapsString.trim());
            this.setState({
                addressMapsString: addressMapsString
            });
        }
    }

    renderGoogleMap = () => {
        if(this.state.addressMapsString !== '') {
            return (
                <iframe className="showtix-event__details__map"
                           width=""
                           height=""
                           frameBorder="0" style={{border:0}}
                           allowFullScreen
                           src={`https://www.google.com/maps/embed/v1/place?key=${this.state.apiKey}&q=${this.state.addressMapsString}`}
                           title="Google Map of the Event location"
                ></iframe>
            )
        }
    };

    renderEventWebsite = (event) => {
        if(event.event_website !== null && event.event_website !== '') {
            if (event.event_website.indexOf('http') != -1) {
                return (
                    <React.Fragment>
                        <br /><a target="_blank" rel="noopener" href={event.event_website}>{event.event_website}</a>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <br /><a target="_blank" rel="noopener" href={"http://" + event.event_website}>{event.event_website}</a>
                    </React.Fragment>
                );
            }
        }
    };

    renderPlaybilderUrl = (event) => {
        if(event.playbilder_url !== null && event.playbilder_url !== '') {
            if (event.playbilder_url.indexOf('http') != -1) {
                return (
                    <React.Fragment>
                        <br /><a target="_blank" className="showtix-button showtix-button__small showtix-background__primary-2" rel="noopener" href={event.playbilder_url}>Show Program</a>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <br /><a target="_blank" className="showtix-button showtix-button__small showtix-background__primary-2" rel="noopener" href={"http://" + event.playbilder_url}>Show Program</a>
                    </React.Fragment>
                );
            }
        }
    };

    renderContactEmail = (event) => {
        if(event.contact_email !== null && event.contact_email !== '') {
            return (
                <React.Fragment>
                    <br /><a href={"mailto:" + event.contact_email}>{event.contact_email}</a>
                </React.Fragment>
            )
        }
    };

    renderServiceFee = (event) => {
        if(event.service_fee === 'customer') {
            return (
                <p className="showtix-note"><em>{this.props.strings.priceNote}</em></p>
            )
        }
    };

    render() {
        const event = this.props.event;
        return (
            <div className="showtix-section pl-0 pr-0">
                <div className="showtix-event__details">
                    <div className="showtix-event__details__content">
                        <h2 className="showtix-event__details__title">
                            <span className="showtix-event__details__pretitle">{this.props.strings.presentedBy}<br />{ReactHtmlParser(this.props.client.client_name)}</span>
                            {ReactHtmlParser(event.name)}
                        </h2>
                            <div className="showtix-event__details__info">
                                <div className="showtix-event__details__info__content">
                                    <h3 className="showtix-event__details__section-title">General info</h3>

                                    <p>
                                    <strong>{event.venue.name}</strong>
                                    <br />
                                    {ReactHtmlParser(event.venue.address + "<br />" + event.venue.city + ", " + event.venue.state + "<br />" + event.venue.zip)}
                                    <br />
                                    <a target="_blank" rel="noopener" href={`https://maps.google.com/?q=${this.state.addressMapsString}`}>{this.props.strings.getDirections}</a><br /><br />

                                    {event.contact_phone}

                                    { this.renderEventWebsite(event) }

                                    { this.renderPlaybilderUrl(event) }

                                    { this.renderContactEmail(event) }
                                    </p>

                                    { this.renderServiceFee(event) }
                                </div>

                                { this.renderGoogleMap() }

                                {/*<h2 className="showtix-event__details__section-title">Important dates</h2>*/}
                            </div>
                    </div>
                </div>
            </div>
        );
    }
}

LandingDetails.propTypes = {
    
}

export default LandingDetails;


// WEBPACK FOOTER //
// ./src/components/EventLanding/LandingDetails/LandingDetails.js